module.exports = __webpack_public_path__ + "static/media/aion-debit-card.74b04fd4.png";